import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { Props } from '../src/Buttons/SiteSettingsHelpPanelLink.tsx';

export const SiteSettingsHelpPanelLink: LoadableType<Props> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ButtonsSiteSettingsHelpPanelLink" */ '../src/Buttons/SiteSettingsHelpPanelLink.tsx'
			)
		).SiteSettingsHelpPanelLink,
});
